<script lang="ts">import FieldLabel from '../FieldLabel/FieldLabel.svelte';
import ValidationMessage from '../ValidationMessage/ValidationMessage.svelte';
export let colorMode = 'light';
export let label = '';
export let id = undefined;
export let name;
export let placeholder = '';
export let disabled = false;
export let invalid = false;
export let readonly = false;
export let required = false;
export let value = '';
export let validationMessage = '';
</script>

<div {...$$restProps} class="TextareaField {$$restProps.class || ''}" data-color-mode={colorMode}>
  {#if label}
    <FieldLabel for={id || name} {disabled} text={label} />
  {/if}

  <textarea
    id={id || name}
    {name}
    {placeholder}
    {disabled}
    {required}
    {readonly}
    rows="3"
    bind:value
    aria-invalid={invalid}
    aria-describedby={invalid ? `textarea-error-${name}` : undefined}
  ></textarea>

  {#if validationMessage && invalid}
    <ValidationMessage id="textarea-error-{name}" text={validationMessage} {colorMode} />
  {/if}
</div>

<style>.TextareaField textarea {
  font-weight: var(--form-field-input-font-weight);
  font-size: var(--form-field-input-font-size);
  letter-spacing: var(--form-field-input-letter-spacing);
  line-height: var(--form-field-input-line-height);
}

/**
 * Checkbox styling is shared between CheckboxesField and MultiSelectField
 * The biggest difference between the two is the hover/focus/etc states are on different elements, so it cannot just be
 * one big mixin and has to be broken up
 */
.TextareaField {
  --color: var(--color-text);
}
.TextareaField:has(textarea:disabled), .TextareaField:has(textarea:read-only) {
  pointer-events: none;
}
.TextareaField textarea {
  --form-field-inset-box-shadow-size: 1px;
  --form-field-inset-box-shadow-color: var(--color-form-field-default);
  box-shadow: inset 0 0 0 var(--form-field-inset-box-shadow-size) var(--form-field-inset-box-shadow-color);
  display: block;
  width: 100%;
  padding: var(--form-field-input-padding);
  background-color: var(--color-background);
  border-radius: var(--textarea-field-border-radius);
}
.TextareaField textarea::placeholder {
  color: var(--color-form-field-placeholder);
}
.TextareaField textarea:hover {
  --form-field-inset-box-shadow-size: 1px;
  --form-field-inset-box-shadow-color: var(--color-form-field-hover);
}
.TextareaField textarea:focus {
  --form-field-inset-box-shadow-size: 2px;
  --form-field-inset-box-shadow-color: var(--color-form-field-focus);
}
.TextareaField textarea:active {
  --form-field-inset-box-shadow-size: 2px;
  --form-field-inset-box-shadow-color: var(--color-form-field-active);
}
.TextareaField textarea:disabled, .TextareaField textarea:read-only {
  --form-field-inset-box-shadow-size: 1px;
  --form-field-inset-box-shadow-color: var(--color-form-field-disabled-box-shadow);
  background-color: var(--color-form-field-disabled-background-color);
}
.TextareaField textarea[aria-invalid=true] {
  --form-field-inset-box-shadow-color: var(--color-critical);
}</style>
